<div class="custom-mat-dialog-form mTab">
  <mat-tab-group [selectedIndex]="0">
    <mat-tab id="Tab2">
      <ng-template mat-tab-label>
        Change Log
      </ng-template>
      <p>&nbsp;</p>

      <span class="title">{{config.type || config.entityType}}</span>
      <p class="kpidetailblock">
        {{config.element.Name || config.element.name || config.title}}
      </p>

      <div class="table-container">
        <table mat-table
          [dataSource]="dataSource"
          multiTemplateDataRows
          class="mat-elevation-z8 mat-table-custom my-table">

          @for (column of config.columns; track column) {
            <ng-container [matColumnDef]="column.key">
              <th mat-header-cell *matHeaderCellDef [ngClass]="'column-' + column.key">
                <div class="header-content">
                  <span>{{column.header}}</span>
                  @if (column.key === 'fiscalYear' && config.entityType === 'impact') {
                    <mat-select
                      hideSingleSelectionIndicator
                      class="column-filter"
                      [(value)]="selectedYear"
                      (selectionChange)="applyFilters()"
                      placeholder="All">
                      <mat-option value="">All</mat-option>
                      @for (year of availableYears; track year) {
                        <mat-option [value]="year">{{formatFiscalYear(year)}}</mat-option>
                      }
                    </mat-select>
                  }
                  @if (column.key === 'period' && config.entityType === 'impact') {
                    <mat-select
                      hideSingleSelectionIndicator
                      class="column-filter"
                      [(value)]="selectedPeriod"
                      (selectionChange)="applyFilters()"
                      placeholder="All">
                      <mat-option value="">All</mat-option>
                      @for (period of availablePeriods; track period) {
                        <mat-option [value]="period">{{formatPeriod(period)}}</mat-option>
                      }
                    </mat-select>
                  }
                </div>
              </th>
              <td mat-cell *matCellDef="let element" [ngClass]="'column-' + column.key">
                @switch (column.type) {
                  @case ('operation') {
                    <p>
                      {{formatCellValue(element, column)}}
                    </p>
                  }
                  @case ('date') {
                    <p>
                      {{element[column.key] | date:'yyyy-MM-dd HH:mm'}}
                    </p>
                  }
                  @default {
                    <p [innerHTML]="formatCellValue(element, column)">
                    </p>
                  }
                }
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div style="margin-top:30px;">
    <p>&nbsp;</p>
    <p>
      <button type="button"
        class="btn btn-danger"
        (click)="onClose()">
        Close
      </button>
    </p>
  </div>
</div>